<template>
	<div class="erji">
		
		
		<template v-if="this.menuID == this.branchId && !this.ddid">
			<div class="banner-2"
			:style="{ backgroundImage: 'url('+icoURL+'storage/'+this.bannerUrl+')'}"
			></div>
			<div class="menu-wp">
				<div class="container">
					<div class="menu-dl">
						<dl>
							<dd class="cur">
							{{branchName}}
							</dd>
						</dl>
						<div class="clear"></div>
					</div>
				</div>
			</div>
		</template>
		
		<template v-else-if="this.ddid">
			<div class="banner-2"
			:style="{ backgroundImage: 'url('+icoURL+'storage/'+this.bannerUrl+')'}"
			></div>
			<hmenu :curID="this.curID" :menuID="this.menuID"></hmenu>
		</template>

		
		<template v-else>
			<div class="banner-2" 
			:style="{ backgroundImage: 'url('+icoURL+'storage/'+this.bannerUrl+')'}"
			></div>
			<hmenu :curID="this.curID" :menuID="this.menuID" @son-btn="sonbtns($event)"></hmenu>
		</template>
		
		
		<router-view></router-view>
		
		
	</div>
</template>

<script>
	export default{
		name:'slider',
		data(){
			return{
				menuID:'',
				curID:'',
				bannerCur:'',
				bannerUrl:'',
				branchId:1416,
				branchName:'分支机构',
				ddid:false
			}
		},
		methods:{
			//请求分类banner
			res_bannerx(e){
				this.axios.get("/api/menus/class?id="+e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.bannerUrl = response.data.reslut.banner;
							// this.branchName = response.data.reslut.name;
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			sonbtns (val) {
			// val===> { "sondata": "我是子组件的值" }
				this.bannerCur = val.sondata
				if(this.bannerCur){
					this.res_bannerx(this.bannerCur);
					console.log('001')
				}else{
					this.res_bannerx(this.$route.params.id);
					console.log('002')
				}
			}
		},
		created(){
			this.menuID = this.$route.params.id;
			this.curID = this.$route.query.category_id;
			// if(this.menuID == this.branchId){
			// 	this.res_bannerx(this.branchId);
			// 	console.log('created')
			// }
		},
		watch :{
			'$route' (to, from) {
					// 对路由变化作出响应...
					this.menuID = to.params.id;
					this.curID = to.query.category_id;
					if(to.path.slice(-7) == 'deliver') {
						this.ddid = true;
						this.res_bannerx(this.$route.params.id);
					}else{
						this.res_bannerx(this.$route.query.category_id);
						this.ddid = false;
					}
			},
			'menuID' (to,form){
				if(this.menuID == this.branchId){
					this.res_bannerx(this.branchId);
					console.log('branchId')
				}else{
					if(Number(form) != this.branchId && form != ''){
						this.res_bannerx(this.$route.query.category_id);
						console.log('哪次请求?')
					}
				}
				// console.log('监听到menuID切换')
			}
		},
	}
</script>

<style>
</style>